import { connect } from 'react-redux';

import ChecklistFilterTag from './ChecklistFilterTag';
import { makeGetTaskFacetLabel } from '../../../../../selectors/checklist/checklistSelectors';

const makeMapStateToProps = () => {
  const getFacetLabel = makeGetTaskFacetLabel();

  return (state, props) => ({
    facetLabel: getFacetLabel(state, props),
  });
};

export default connect(makeMapStateToProps)(ChecklistFilterTag);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistActiveFilterTags/ChecklistFilterTag/index.js